import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCarouselSlidesResponse = objectOf({
  carousel_slides: arrayOf(
    objectOf({
      id: string,
      value: string,
      step_id: string,
    })
  ),
});
